import { createTheme, MantineColorsTuple } from '@mantine/core';

// Canonical Tafura colors (match shared/styles/tokens.css semantics)
const primary: MantineColorsTuple = [
  '#E6F7F5',
  '#CCEFEB',
  '#99DFD7',
  '#66CFC3',
  '#33BFAF',
  '#2A9D8F',
  '#228073',
  '#1A6358',
  '#12463C',
  '#0A2921',
];

// Warm orange accent for prices/deals
const accent: MantineColorsTuple = [
  '#FFF7ED',
  '#FFEDD5',
  '#FED7AA',
  '#FDAB78',
  '#FB923C',
  '#F97316',
  '#EA580C',
  '#C2410C',
  '#9A3412',
  '#7C2D12',
];

// Success
const secondary: MantineColorsTuple = [
  '#E6F9F0',
  '#CCF3E1',
  '#99E7C3',
  '#66DBA5',
  '#33CF87',
  '#00C369',
  '#009A54',
  '#00733F',
  '#004D2A',
  '#002615',
];

export const theme = createTheme({
  primaryColor: 'primary',
  primaryShade: { light: 5, dark: 4 },

  colors: {
    primary,
    accent,
    secondary,
  },

  autoContrast: true,
  luminanceThreshold: 0.3,

  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif',

  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '1.75rem', lineHeight: '1.25' },
      h2: { fontSize: '1.5rem', lineHeight: '1.3' },
      h3: { fontSize: '1.25rem', lineHeight: '1.35' },
      h4: { fontSize: '1.125rem', lineHeight: '1.4' },
      h5: { fontSize: '1rem', lineHeight: '1.5' },
      h6: { fontSize: '0.875rem', lineHeight: '1.5' },
    },
  },

  defaultRadius: 'md',

  shadows: {
    xs: '0 1px 2px rgba(0, 0, 0, 0.04)',
    sm: '0 2px 4px rgba(0, 0, 0, 0.06)',
    md: '0 4px 8px rgba(0, 0, 0, 0.08)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.1)',
    xl: '0 12px 24px rgba(0, 0, 0, 0.12)',
  },

  components: {
    Button: {
      defaultProps: {
        radius: 'lg',
      },
      styles: {
        root: {
          fontWeight: 600,
          transition: 'all 0.2s ease',
        },
      },
    },

    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
    },

    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },

    Select: {
      defaultProps: {
        radius: 'md',
      },
    },

    Badge: {
      defaultProps: {
        radius: 'md',
      },
    },

    ActionIcon: {
      defaultProps: {
        radius: 'xl',
      },
    },

    Modal: {
      defaultProps: {
        radius: 'md',
        centered: true,
      },
    },

    Drawer: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});

